import { EntityTreeContext } from './entity-tree-context';
import { Progression } from './progression';

export class EmptyProgression implements Progression {
  id: string = null;
  data: any = null;
  meta: any = null;
  context: Array<EntityTreeContext> = null;
  resourceType: string = null;
  name: string = null;
}
